const TORONTO_TIME_ZONE = 'America/Toronto'

const pad = value => String(value).padStart(2, '0')

function getTorontoParts (timestamp) {
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: TORONTO_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  })
  const values = {}
  formatter.formatToParts(new Date(timestamp)).forEach(part => {
    if (part.type !== 'literal') values[part.type] = Number(part.value)
  })
  return values
}

function getTorontoOffset (timestamp) {
  const parts = getTorontoParts(timestamp)
  const utcFromParts = Date.UTC(
    parts.year,
    parts.month - 1,
    parts.day,
    parts.hour,
    parts.minute,
    parts.second
  )
  return utcFromParts - Math.floor(timestamp / 1000) * 1000
}

export function toTorontoDateTimeInput (timestamp = Date.now()) {
  const parts = getTorontoParts(Number(timestamp) || Date.now())
  return `${parts.year}-${pad(parts.month)}-${pad(parts.day)}T${pad(parts.hour)}:${pad(parts.minute)}`
}

export function fromTorontoDateTimeInput (value) {
  const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/)
  if (!match) return NaN

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const hour = Number(match[4])
  const minute = Number(match[5])
  const utcGuess = Date.UTC(year, month - 1, day, hour, minute)
  let offset = getTorontoOffset(utcGuess)
  let timestamp = utcGuess - offset
  const correctedOffset = getTorontoOffset(timestamp)

  if (correctedOffset !== offset) {
    offset = correctedOffset
    timestamp = utcGuess - offset
  }

  return timestamp
}

export function formatTorontoDateTime (timestamp) {
  if (!timestamp) return '—'
  const date = new Date(Number(timestamp))
  if (isNaN(date.getTime())) return '—'
  return new Intl.DateTimeFormat(undefined, {
    timeZone: TORONTO_TIME_ZONE,
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  }).format(date)
}

export { TORONTO_TIME_ZONE }
